import { render, staticRenderFns } from "./wkCheckBoxGroup.vue?vue&type=template&id=c01b29ac&scoped=true"
import script from "./wkCheckBoxGroup.vue?vue&type=script&lang=js"
export * from "./wkCheckBoxGroup.vue?vue&type=script&lang=js"
import style0 from "./wkCheckBoxGroup.vue?vue&type=style&index=0&id=c01b29ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01b29ac",
  null
  
)

export default component.exports